<template>
  <div id="cookies-eu-banner-container" class="cookies-banner">

    <div id="cookies-eu-banner" :class="{'hidden':hidden}">

      <div class="cookie-main">

        <div class="text-info">
<!--          <div class="cookie-title main-title" v-html="fields.field_one.value.title"></div>-->
          <div class="cookie-text" v-html="fields.field_one.value.description"></div>
          <div class="cookie-title" v-html="fields.field_one.value.title2"></div>
          <div class="cookie-buttons">
            <div class="button-wrapper">
              <button id="cookies-eu-accept" @click="initializeGoogleAnalytics"
                      v-html="fields.field_one.value.buttonAccept"></button>
<!--              <div class="button-description" v-html="fields.field_one.value.acceptDescription"></div>-->
            </div>
            <div class="button-wrapper">
              <button id="cookies-eu-reject" @click="closeCookiesBanner"
                      v-html="fields.field_one.value.buttonReject"></button>
<!--              <div class="button-description" v-html="fields.field_one.value.rejectDescription"></div>-->
            </div>
          </div>
          <div class="privacy-wrapper">
            <span class="cookie-text" v-html="fields.field_one.value.privacy"></span>
            <span class="cookie-text privacy-link" @click="$emit('openPolicyPopup')"
                 v-html="fields.field_one.value.privacyLink"></span>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CookiesBanner",
  props: {
    fields: {
      type: Object
    }
  },

  data() {
    return {
      hidden: false,
    }
  },

  methods: {
    initializeGoogleAnalytics() {
      window.dataLayer = window.dataLayer || [];

      function gtag() {
        dataLayer.push(arguments);
      }

      gtag('js', new Date());
      gtag('config', 'G-N9ECCSJLYK');

      this.hidden = true
    },
    closeCookiesBanner() {
      this.hidden = true
    }
  },
}
;
</script>

<style lang='scss'>
@import "CookiesBanner";
</style>

